export default __webpack_public_path__ + "media/images/landing-14-550x420-5e775bd9751041b272ed361962d5d27d.jpg";